import { render } from "./index.vue?vue&type=template&id=02c75868"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/componentBase/AlbbPublishProduct/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "02c75868"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('02c75868', __exports__)) {
    api.reload('02c75868', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=02c75868", () => {
    api.rerender('02c75868', render)
  })

}


export default __exports__